import { byAttrVal, createCustomElement, DOMModel } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import { ReactElement } from 'react'

import { FirstInvoiceModal } from '@views/invoices/elements/FirstInvoiceModal'

import { ThemeProvider } from '../../contexts/themeProvider'

class FirstInvoiceModalWebComponent extends DOMModel {
  @byAttrVal organizationId: string
}

interface FirstInvoiceModalProps {
  organizationId: string
}

export function FirstInvoiceModalModule({ organizationId }: FirstInvoiceModalProps): ReactElement {
  return (
    <ThemeProvider>
      <ModalContextProvider>
        <FirstInvoiceModal />
      </ModalContextProvider>
    </ThemeProvider>
  )
}

const FirstInvoiceModalCustomElement = createCustomElement(
  FirstInvoiceModalModule,
  FirstInvoiceModalWebComponent,
  'element',
)

customElements.get('first-invoice-modal-module') ||
  customElements.define('first-invoice-modal-module', FirstInvoiceModalCustomElement)

export default FirstInvoiceModalCustomElement
